import {Api} from "../../../api/api.js"
import FileSaver from 'file-saver'
import {toast} from "react-toastify";


export const handleDownloadFile = async (id, uri = '/oper/nabory/pliki/download') => {


    try {
        const response = await Api.get(`${uri}/${id}`, {responseType: "blob"});

        if (response.status === 200) {
            const header = response.headers?.['content-disposition'];
            const filename = header?.split(';')
                .find((n) => n.includes('filename='))
                ?.replace('filename=', '')
                ?.replace(/"/g, '')
                ?.trim() || 'file.txt';

            const blob = new Blob([response.data]);
            FileSaver.saveAs(blob, filename);

            toast.success('Plik został pomyślnie pobrany');
        } else {
            toast.error('Błąd podczas pobierania pliku');
        }
    } catch (error) {
        toast.error('Wystąpił nieoczekiwany błąd podczas pobierania pliku');
    }
}


